export default "__VITE_ASSET__c8881b5d__"